import mapTeaser from '../../../../../../src24/js/modules/mapTeaser';

window.addEventListener('load', () => {
    mapTeaser.init();
});
